import { IDocument } from '@/contracts/modules/note/entities/IDocument'
import { IDecryptNote } from '@/contracts/modules/note/use-case/IDecryptNote'
import { INoteState } from '@/contracts/modules/note/use-case/IFoldNote'
import { IPlainNoteState } from '@/contracts/modules/note/use-case/IPlainNoteState'
import { INoteCipher } from '@/contracts/modules/note/cipher/INoteCipher'
import { EnumNotePart } from '@/contracts/modules/note/enum/EnumNotePart'
import { EnumNoteError } from '@/contracts/modules/note/enum/EnumNoteError'
import { NoteCipher } from '@/modules/note/v1/cipher/NoteCipher'

export const EMPTY_CONTENT: IDocument = { type: 'doc', content: [] }

function isDocument(value: unknown): value is IDocument {
  return typeof value === 'object' && value !== null && (value as IDocument).type === 'doc' && Array.isArray((value as IDocument).content)
}

export class DecryptNote implements IDecryptNote {
  constructor(private cipher: INoteCipher = new NoteCipher()) {}

  async exec(state: INoteState, key: CryptoKey): Promise<IPlainNoteState> {
    const conflict = state.conflict === null
      ? null
      : {
        left: { time: state.conflict.left.time, content: await this.document(key, state.conflict.left.content) },
        right: { time: state.conflict.right.time, content: await this.document(key, state.conflict.right.content) },
        base: state.conflict.base === null ? null : await this.document(key, state.conflict.base),
      }

    return {
      key: state.key,
      title: state.title === '' ? '' : await this.cipher.decrypt(key, EnumNotePart.TITLE, state.title),
      content: await this.document(key, state.content),
      isRemoved: state.isRemoved,
      heads: state.heads,
      conflict,
      files: state.files,
      updatedAt: state.updatedAt,
    }
  }

  /** Пустая строка — заметка без правок; расшифрованное не документ — cannot_decrypt */
  private async document(key: CryptoKey, cipher: string): Promise<IDocument> {
    if (cipher === '') {
      return EMPTY_CONTENT
    }
    const text = await this.cipher.decrypt(key, EnumNotePart.CONTENT, cipher)
    let document: unknown
    try {
      document = JSON.parse(text)
    } catch {
      throw new Error(EnumNoteError.CANNOT_DECRYPT)
    }
    if (!isDocument(document)) {
      throw new Error(EnumNoteError.CANNOT_DECRYPT)
    }
    return document
  }
}
